import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import MediaQuery from 'react-responsive';
import { Link } from 'react-router-dom';
import { RootState } from 'modules';
import { Typography, Button, Row, Col, Divider, Tag, Card } from 'antd';
import styled from 'styled-components';
import { Colors, device, PrimaryColor, SecondaryColor, size } from 'GlobalStyles';
import dot from 'assets/icons/dot.svg';
import jkImage from 'assets/images/pages/programOffline/jk.svg';
import hanImage from 'assets/images/pages/programOffline/han.svg';
import seniorImage from 'assets/images/pages/programOffline/button_senior.svg';
import juniorImage from 'assets/images/pages/programOffline/button_junior.png';

let { Title, Text } = Typography;

interface IMainIntroduction2 {
  firstArticle?: boolean;
  bg?: boolean;
  responsiveBg?: boolean;
}

const MainIntroduction2 = ({ contents, linkRequired, difImg }: any) => {
  let { title, subTitle, description, btnTitle, guidePrice } = contents;
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);

  const ProgramBody = ({id, title, explanation} : any) => {
    return (
      <>
        <Col span={8} style={{ paddingRight: '30px'}}>
          <Row align='middle'>
            <Col><Tag color="#87d068"><Title level={4} style={{ color: '#fff' }}>0{id}</Title></Tag></Col>
            <Col><Text strong style={{fontSize: '18px', color: '#000'}}>{title}</Text></Col>
          </Row>
          <Row style={{ marginTop: '10px', paddingLeft: '10px'}}>
            <Col><img src={dot} alt='bullet' /><Text strong style={{fontSize: '16px', color: '#000', marginLeft: '10px'}}>{explanation}</Text></Col>
          </Row>
        </Col>
      </>
    );
  }; 

  const MentorBody = ({title, subtitle, company, education, image, type} : any) => {
    return (
      <>
        <Col span={8}>
          <div className='border-box'>
            <Row align='top'>
              <Col><img src={image} /></Col>
              <Col flex='auto' style={{ paddingLeft: '20px'}}>
                <Row justify='space-between'>
                  <Text strong style={{fontSize: '18px', color: '#000'}}>{title}</Text>
                  <img src={type} />
                </Row>
                <Row><Text style={{fontSize: '16px', color: 'grey'}}>{subtitle}</Text></Row>
                <Divider style={{ margin:'0px'}}/>
                <Row><Text style={{fontSize: '16px', color: 'grey'}}>{company}</Text></Row>
                <Row><Text style={{fontSize: '16px', color: 'grey'}}>{education}</Text></Row>
              </Col>
            </Row>        
          </div>
        </Col>

      </>
    );
  }; 

  return (
    <StyledContainer>
      <MainIntroductionHeader>
        <div>
          <Title>{title}</Title>
          <Text>{subTitle}</Text>
        </div>
      </MainIntroductionHeader>

      <Row gutter={[16, 16]} justify='center' style={{ marginTop: '40px', marginBottom: '10px' }}>
        <Col span={8}><Title level={4} style={{ color: '#000' }}>강의 목차</Title></Col>
        <Col span={8}><div></div></Col>
        <Col span={8}><Title level={4} style={{ color: '#000' }}>멘토 소개</Title></Col>
      </Row>

      <Row gutter={[16, 16]} justify='center' style={{ marginTop: '10px', marginBottom: '30px' }}>
        <ProgramBody id='1' title={description[0].title} explanation={description[0].explanation} />
        <ProgramBody id='3' title={description[2].title} explanation={description[2].explanation} />
        
        <MentorBody title='JK' subtitle='"확실한 효과의 멘토링"' company='BCG 8년 근무' education='서울대학교 산업공학과 졸업'
         type={seniorImage} image={jkImage}/>
      </Row>

      <Row gutter={[16, 16]} justify='center' style={{ marginTop: '10px', marginBottom: '30px' }}>
        <ProgramBody id='2' title={description[1].title} explanation={description[1].explanation} />
        <ProgramBody id='4' title={description[3].title} explanation={description[3].explanation} />
        
        <MentorBody title='Han' subtitle='"검증된 실력"' company='BCG 3년 근무' education='서울대학교 산업공학과 졸업'
         type={juniorImage} image={hanImage}/>
      </Row>

      {guidePrice && (
        <PriceGuideBox>
          <GuidePriceHeader>
            <Title>{guidePrice.title}</Title>
            {guidePrice.subTitle && <Text>* {guidePrice.subTitle}</Text>}
          </GuidePriceHeader>

          {guidePrice.subTitle2 && <Text className='secondSubTitle'>{guidePrice.subTitle2}</Text>}
          
          <GuidePriceTickets>
            {guidePrice.ticket.map((ticket: any) => (
              <div>
                <PriceGuideTicket>
                  <Text className='secondSubTitle'>{ticket.title[0]}</Text>
                  <Text className='secondSubTitle'>{ticket.title[1]}</Text>
                  <Text className='secondSubTitle'>{ticket.title[2]}</Text>
                  {description && (
                    <Text>
                      {ticket.discount && <span className='discount'>정가 {ticket.discount}만원</span>}
                      <span className='price'>{ticket.price}</span>
                      <span className='priceTag'>만원</span> 
                    </Text>
                  )}
                </PriceGuideTicket>

                { /* linkRequired ? <Link to={{pathname:ticket.purchaseLink}} target="_blank">
                  <Button className='secondary'>강의 신청하기</Button>
                  </Link> : <div></div> */}
                <Link to={{pathname:ticket.purchaseLink}} target="_blank">
                  <Button className='secondary'>강의 신청하기</Button>
                </Link>
              </div>
            ))}
          </GuidePriceTickets>
        </PriceGuideBox>
      )}

    </StyledContainer>
  );
};

export default React.memo(MainIntroduction2);

const StyledContainer = styled.article<IMainIntroduction2>`
  max-width: 1440px;
  margin: 0 auto;
  padding: 50px 50px 70px 50px;

  @media screen and ${device.lg} {
    padding: 35px 20px;
  }

  button.secondary {
    display: block;
    width: 134px;
    height: 44px;
    margin: 0 auto;

    @media screen and ${device.lg} {
      width: 100%;
    }
  }
`;

const MainIntroductionHeader = styled.header<IMainIntroduction2>`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media screen and ${device.lg} {
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }

  h1.ant-typography {
    margin: 0 0 3px 0;
    font-size: 24px;
    color: ${({ bg }) => (bg ? '#ffffff' : SecondaryColor)};

    @media screen and ${device.lg} {
      font-size: 20px;
    }
  }

  span.ant-typography {
    display: inline-block;
    max-width: 800px;
    font-size: 20px;
    color: ${({ bg }) => (bg ? '#ffffff' : PrimaryColor)};

    @media screen and ${device.lg} {
      max-width: 100%;
      font-size: 16px;
    }
  }

  .btnArea {
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    @media screen and ${device.lg} {
      width: 100%;
    }

    a {
      @media screen and ${device.lg} {
        width: 100%;
      }

      .ant-btn-primary {
        width: 100%;
        margin-top: 25px;
      }
    }

    .subTitle {
      margin-top: 4px;
      color: #e4e4e4;

      @media screen and ${device.lg} {
        display: none;
      }
    }
  }
`;

const DetailIntroductionImg = styled.img`
  width: 100%;

  @media screen and ${device.lg} {
    margin-top: 25px;
  }
`;

const DetailIntroductionTitle = styled.div<IMainIntroduction2>`
  margin-top: 20px;
  font-size: 20px;
  font-weight: 700;
  color: ${({ bg }) => bg && '#ffffff'};

  @media screen and ${device.lg} {
    margin-top: 15px;
    font-size: 18px;
  }
`;

const DetailExplanation = styled.div<IMainIntroduction2>`
  font-size: 18px;
  color: ${({ bg }) => bg && '#ffffff'};

  @media screen and ${device.lg} {
    font-size: 14px;
  }
`;

const Descriptions = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  margin-top: 25px;

  @media screen and ${device.lg} {
    flex-direction: column;
    align-items: center;
  }

  .plusIcon {
    margin: 0 30px;
    font-size: 50px;
    line-height: 400px;

    @media screen and ${device.lg} {
      display: none;
    }
  }
`;

const Description = styled.div`
  max-width: 446px;
  flex: 1;
  padding: 0 16px;

  @media screen and ${device.lg} {
    max-width: 100%;
    width: 100%;
    padding: 0;
  }
`;

const Explanations = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;

  .bullet {
    margin-right: 7px;
  }
`;

const PriceGuideBox = styled.div`
  margin-top: 25px;
  padding: 20px 45px;
  border: 1px solid ${SecondaryColor};
  border-radius: 10px;
  background: #ffffff;

  @media screen and ${device.lg} {
    padding: 25px 15px;
  }

  .secondSubTitle {
    display: block;
    margin: 10px 0 0 0;
    color: ${PrimaryColor};
  }
`;

const GuidePriceHeader = styled.header`
  display: flex;
  align-items: center;

  @media screen and ${device.lg} {
    flex-direction: column;
    align-items: flex-start;
  }

  h1.ant-typography {
    margin: 0 10px 0 0;
    color: #141121;
    font-size: 20px;
  }

  span.ant-typography {
    color: #747474;
  }
`;

const GuidePriceTickets = styled.div`
  display: flex;
  justify-content: center;

  @media screen and ${device.lg} {
    flex-direction: column;
  }

  .ant-btn.secondary.purchased {
    width: auto;

    @media screen and ${device.lg} {
      width: 100%;
    }
  }
`;

const PriceGuideTicket = styled.div`
  width: 356px;
  margin: 15px 15px;
  padding: 25px 0;
  border-radius: 10px;
  background: #f9f9f9;
  white-space: pre-wrap;

  @media screen and ${device.xl} {
    width: 260px;
  }

  @media screen and ${device.lg} {
    width: 100%;
    margin: 25px 0;
  }

  h1.ant-typography {
    margin: 0;
    font-size: 18px;
    text-align: center;
    line-height: 26px;
    color: ${PrimaryColor};

    @media screen and ${device.xl} {
      font-size: 16px;
    }

    @media screen and ${device.lg} {
      font-size: 18px;
    }
  }

  span.ant-typography {
    display: block;
    text-align: center;

    .price {
      margin-right: 5px;
      font-size: 48px;
      color: ${SecondaryColor};
    }

    .priceTag {
      font-size: 18px;
      color: ${SecondaryColor};
    }

    .period,
    .discount {
      font-size: 18px;
      color: #747474;
    }

    .discount {
      margin-right: 10px;
      text-decoration: line-through;
    }
  }
`;
